import script from "./WorkspaceSelection.vue?vue&type=script&setup=true&lang=ts&generic=T%20extends%20SessionWorkspace%20%7C%20WorkspaceItem"
export * from "./WorkspaceSelection.vue?vue&type=script&setup=true&lang=ts&generic=T%20extends%20SessionWorkspace%20%7C%20WorkspaceItem"

const __exports__ = script;

export default __exports__